const o = {
  id: "OhioPick3",
  logo: !0,
  name: "Pick 3",
  style: {
    colorPrimary: "#0054b6"
  }
};
export {
  o as default
};
